// NPM Imports
import React from "react";
import Modal from "react-responsive-modal";

import { Button } from "../../../../../revvComponents";

const MergeCellConfirmation = ({ closePopup, mergeCells }) => (
  <Modal open onClose={closePopup} closeOnOverlayClick={false} center>
    <div
      className="modal-container table-gsheet-popup-container"
      data-test="table-gsheet-popup-container">
      <div
        className="modal-heading table-to-gsheet-heading"
        data-test="table-gsheet-popup-modal-heading">
        <span>Heads Up!</span>
      </div>
      <div className="modal-form">
        <div className="modal-form-field" data-test="table-gsheet-popup-form">
          Merging cells will only preserve the top-leftmost value. Merge anyway?
        </div>
      </div>

      <div className="modal-footer">
        <Button
          className="btn btn-transparent modal-footer-btn cancle-btn"
          data-test="table-gsheet-popup-cancle-btn"
          onMouseDown={closePopup}>
          Go back
        </Button>
        <Button
          className="btn btn-primary modal-footer-btn submit-btn"
          data-test="table-gsheet-popup-submit-btn"
          onMouseDown={mergeCells}>
          Continue
        </Button>
      </div>
    </div>
  </Modal>
);

export default MergeCellConfirmation;
